import { useEffect, useState } from "react"
import { WINDOW_WIDTH } from "src/libs/interfaces/layouts"
import { ILandingConsoleStore, useLandingConsoleStore } from "src/modules/pe-landing-module/data/store"

/* Protopia Ecosystem component */
export interface ILandingEditorContainerProps {
   children: JSX.Element[]
}
const LandingEditorContainer = (props: ILandingEditorContainerProps): JSX.Element => {
     const [currentDimensionEdit, setCurrentDimensionEdit]   = useState<WINDOW_WIDTH>( WINDOW_WIDTH.PANEL ) 
    useEffect(() => useLandingConsoleStore.subscribe(
        (state: ILandingConsoleStore) => { 
            setCurrentDimensionEdit( state.currentDimensionEdit ) 
        }
    ), [])
    return <div className={ `w-100 ` } data-cont-edit={ currentDimensionEdit } > 
       {props.children}
    </div>
}
export default LandingEditorContainer